window.onload = function() {
    var buttons = document.getElementsByClassName('cbb-frequently-bought-add-button btn add-to-cart');
    var button = buttons[0];
    if(button == null){
        console.log('Button is null!');
    } else {
        button.addEventListener('click', function() {
            console.log('FBT Add to cart Clicked!');
          setTimeout(function() {
            console.log('Entered Timeout!');
           window.monster_refresh();
           window.openCart();            
            
        }, 800);
          console.log('Exited Timeout!');
        });
    }
};

